import { useNavigate } from 'react-router-dom';
import { Cell, Badge, Text } from '@telegram-apps/telegram-ui';
import type { DealWithDetails } from '../types';

interface DealCardProps {
  deal: DealWithDetails;
}

/**
 * Карточка сделки в списке
 */
export function DealCard({ deal }: DealCardProps) {
  const navigate = useNavigate();

  // Определяем цвет бейджа воронки
  const funnelColor = deal.categoryId === 0 ? '#2196F3' : '#FF9800';

  // Форматируем дату
  const dateStr = new Date(deal.dateCreate).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  // Форматируем сумму
  const amountStr = deal.opportunity > 0
    ? `${deal.opportunity.toLocaleString('ru-RU')} руб.`
    : '';

  return (
    <Cell
      onClick={() => navigate(`/deal/${deal.id}`)}
      subtitle={
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '4px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
            <span style={{
              background: funnelColor,
              color: '#fff',
              padding: '2px 8px',
              borderRadius: '4px',
              fontSize: '11px',
              fontWeight: 500,
            }}>
              {deal.funnelName}
            </span>
            {(() => {
              let statusText: string;
              let statusColor: string;
              let statusBg: string;
              if (deal.isFail) {
                statusText = 'Отклонена';
                statusColor = '#ff3b30';
                statusBg = 'rgba(255,59,48,0.1)';
              } else if (deal.clientStageName === 'Завершена') {
                statusText = 'Завершена';
                statusColor = '#4caf50';
                statusBg = 'rgba(76,175,80,0.1)';
              } else if (deal.isActionRequired) {
                statusText = deal.clientStageName;
                statusColor = '#ff9500';
                statusBg = 'rgba(255,149,0,0.1)';
              } else {
                statusText = 'В работе';
                statusColor = '#2196f3';
                statusBg = 'rgba(33,150,243,0.1)';
              }
              return (
                <span style={{
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '11px',
                  fontWeight: 500,
                  color: statusColor,
                  backgroundColor: statusBg,
                }}>
                  {statusText}
                </span>
              );
            })()}
          </div>
          <div style={{ display: 'flex', gap: '12px', fontSize: '12px', color: 'var(--tgui--hint_color)' }}>
            <span>{dateStr}</span>
            {amountStr && <span>{amountStr}</span>}
          </div>
        </div>
      }
      after={
        deal.isActionRequired ? (
          <Badge type="number" style={{ backgroundColor: '#ff3b30' }}>
            !
          </Badge>
        ) : undefined
      }
      style={{
        borderLeft: `3px solid ${deal.isFail ? '#ff3b30' : deal.isActionRequired ? '#ff9500' : 'transparent'}`,
      }}
    >
      <Text weight="2">
        #{deal.id} {deal.title}
      </Text>
    </Cell>
  );
}
